import { InfoBarCustomAction } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import loc from 'owa-localize';
import { ClientMessage } from 'owa-mail-store';
import {
    warningSubmittedMessageNotSent,
    warningMessageSubmitted,
} from './createMessageSubmittedInfoBarMessage.locstring.json';

type MessageSubmittedInfoBarReturnType = string | InfoBarCustomAction;
const SUBMITTED_MESSAGE_INFO_BAR_MAX_TIME = 5 * 60 * 1000;

export default function createMessageSubmittedInfoBarMessage(
    message: ClientMessage
): MessageSubmittedInfoBarReturnType[] {
    if (message.IsSubmitted) {
        if (message.DeferredSendTime) {
            return [];
        } else {
            if (
                Date.now() - new Date(message.LastModifiedTime).getTime() >
                SUBMITTED_MESSAGE_INFO_BAR_MAX_TIME
            ) {
                return [loc(warningSubmittedMessageNotSent)];
            } else {
                return [loc(warningMessageSubmitted)];
            }
        }
    } else {
        return [];
    }
}
